<template>
  <div class="one-list" :id="id">
    <div class="one-list__info">
      <div class="one-list__info-item">
        <div class="info-title has-store">
          購買日期
        </div>
        <div class="info-content ">
          <span class="date">{{ order.order_date }}</span>
          <span class="store">{{ order.branch }}</span>
        </div>
      </div>

      <div class="one-list__info-item">
        <div class="info-title">
          銷售單號
        </div>
        <div class="info-content">
          <span class="">{{ order.no }}</span>
        </div>
      </div>

      <div class="one-list__info-item">
        <div class="info-title">
          銷售人員
        </div>
        <div class="info-content">
          <span class="">{{ order.user }}</span>
        </div>
      </div>

      <div class="one-list__info-item">
        <div class="info-title">
          發票號碼
        </div>
        <div class="info-content">
          <span class="">
            {{ isPrintInvoice }}
          </span>
        </div>
      </div>

      <div class="one-list__info-item">
        <div class="info-title">
          總金額
        </div>
        <div class="info-content">
          <span class="total-price">$ {{ order.receivable_amount }}</span>
        </div>
      </div>

      <div class="one-list__info-item">
        <div v-if="order.payment_status != 1">
          <div class="info-title">
            欠費
          </div>
          <div class="info-content">
            <span class="owe-money">$ {{ order.unpaid_amount }}</span>
          </div>
        </div>
      </div>

      <div class="one-list__info-item">
        <div v-show="order.payment_status != 1">
          <router-link
            :to="{
              name: '付款',
              query: {
                order_id: order.order_id
              }
            }"
            class="custom-btn alert-btn"
          >
            繳費
          </router-link>
        </div>
        <div v-if="!invoiceIssued">
          <router-link
            :to="{
              name: '開立發票',
              params: {
                order_id: order.order_id
              }
            }"
            class="custom-btn"
          >
            開立發票
          </router-link>
        </div>
        <div v-else>
          <button class="custom-btn" @click="issueDetail">
            列印明細
          </button>
        </div>
      </div>
    </div>

    <div class="one-list__purchase-title">
      <div class="one-title buy-content">
        購買內容
      </div>

      <div class="one-title">
        單價
      </div>

      <div class="one-title amount">
        數量
      </div>

      <div class="one-title">
        優惠
      </div>

      <div class="one-title">
        小計
      </div>
    </div>

    <div class="one-list__purchase-product-outer">
      <OneProduct
        :orderItem="firstOrderItem"
        v-show="!showMore && this.orderItems.length != 0"
      />
      <template v-for="orderItem in orderItems">
        <OneProduct
          :orderItem="orderItem"
          :key="orderItem.order_item_id"
          v-show="showMore"
        />
      </template>

      <div class="calculation-area" v-show="showMore">
        <div class="giveaway calculation-item">
          <div class="calculation-item__title">購買金額</div>
          <div class="calculation-item__number black">
            {{ Math.max(order.total, order.subtotal) }}
          </div>
        </div>

        <div
          class="giveaway calculation-item"
          v-if="order.level_discount_amount != 0"
        >
          <div class="calculation-item__title">會員方案優惠</div>
          <div class="calculation-item__number">
            -$ {{ order.level_discount_amount }}
          </div>
        </div>

        <div
          class="giveaway calculation-item"
          v-if="order.giveaway_discount_amount != 0"
        >
          <div class="calculation-item__title">贈品</div>
          <div class="calculation-item__number">
            {{ order.giveaway_discount_amount }}
          </div>
        </div>

        <div
          class="giveaway calculation-item"
          v-if="order.combination_discount_amount != 0"
        >
          <div class="calculation-item__title">商品促銷折抵</div>
          <div class="calculation-item__number">
            -$ {{ order.combination_discount_amount }}
          </div>
        </div>

        <div
          class="giveaway calculation-item"
          v-if="order.product_discount_price != 0"
        >
          <div class="calculation-item__title">商品折價</div>
          <div class="calculation-item__number">
            -$ {{ order.product_discount_price }}
          </div>
        </div>

        <div
          class="giveaway calculation-item"
          v-if="order.product_discount_percent != 0"
        >
          <div class="calculation-item__title">商品折扣</div>
          <div class="calculation-item__number">
            -$ {{ order.product_discount_percent }}
          </div>
        </div>

        <div
          class="giveaway calculation-item"
          v-if="order.program_discount_percent != 0"
        >
          <div class="calculation-item__title">方案折扣</div>
          <div class="calculation-item__number">
            -$ {{ order.program_discount_percent }}
          </div>
        </div>

        <div
          class="giveaway calculation-item"
          v-if="order.program_discount_price != 0"
        >
          <div class="calculation-item__title">方案折價</div>
          <div class="calculation-item__number">
            -$ {{ order.program_discount_price }}
          </div>
        </div>

        <div v-for="(coupon, index) in order.coupons" :key="index + 100">
          <div class="discount calculation-item" v-if="coupon.type == 1">
            <div class="calculation-item__title">課程9折折扣券</div>
            <div class="calculation-item__number">-$ {{ coupon.amount }}</div>
          </div>
        </div>

        <div class="the-line"></div>
        <div class="subtotal calculation-item">
          <div class="calculation-item__title">小計</div>
          <div class="calculation-item__number black">
            $ {{ order.subtotal }}
          </div>
        </div>

        <div
          class="subtotal-discount calculation-item"
          v-if="order.subtotal_discount_type === 2"
        >
          <div class="calculation-item__title">小計再折抵</div>
          <div class="calculation-item__number">
            -$ {{ order.subtotal_discount_amount }}
          </div>
        </div>

        <div
          class="subtotal-discount calculation-item"
          v-if="order.subtotal_discount_type === 1"
        >
          <div class="calculation-item__title">小計再折扣</div>
          <div class="calculation-item__number">
            -$ {{ order.subtotal_discount_amount }}
          </div>
        </div>

        <div v-for="(coupon, index) in order.coupons" :key="index">
          <div
            class="subtotal-discount calculation-item"
            v-if="coupon.type == 2"
          >
            <div class="calculation-item__title">商品券100元</div>
            <div class="calculation-item__number">
              -$ {{ 100 * coupon.count }}
            </div>
          </div>
          <div
            class="subtotal-discount calculation-item"
            v-else-if="coupon.type == 3"
          >
            <div class="calculation-item__title">課程券100元</div>
            <div class="calculation-item__number">
              -$ {{ 100 * coupon.count }}
            </div>
          </div>
          <div
            class="subtotal-discount calculation-item"
            v-else-if="coupon.type == 4"
          >
            <div class="calculation-item__title">課程/商品抵用券100元</div>
            <div class="calculation-item__number">
              -$ {{ 100 * coupon.count }}
            </div>
          </div>
        </div>

        <div class="calculation-item total">
          <div class="one-item__title">應收金額</div>
          <div class="one-item__price final-price">
            $ {{ order.receivable_amount }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="handle-receive-payment"
      v-show="showMore"
      v-for="(orderPayment, index) in order.order_payment"
      :key="orderPayment.order_payment_id"
      :index="index"
    >
      <div class="payment__item">
        <div class="payment__item-title">處理日期</div>
        <div class="payment__item-content">{{ orderPayment.created_at }}</div>
      </div>

      <div class="payment__item handle-people">
        <div class="payment__item-title">處理人員</div>
        <div class="payment__item-content">
          {{ orderPayment.user_account }} {{ orderPayment.user_name }}
        </div>
      </div>

      <div class="payment__item">
        <div class="payment__item-title">應收金額</div>
        <div class="payment__item-content">
          $
          {{
            index == 0
              ? order.receivable_amount
              : order.receivable_amount - order.order_payment[0].amount
          }}
        </div>
      </div>

      <div class="payment__item">
        <div class="payment__item-title">實收金額</div>
        <div class="payment__item-content">$ {{ orderPayment.amount }}</div>
      </div>

      <div class="payment__item">
        <div class="payment__item-title">未收金額</div>
        <div class="payment__item-content">
          $
          {{
            index == 0
              ? order.receivable_amount - order.order_payment[0].amount
              : order.unpaid_amount
          }}
        </div>
      </div>
    </div>

    <button
      class="read-more-btn transparent-btn"
      @click="showMoreInfo"
      v-scroll-to="`#${id}`"
    >
      <span v-if="!showMore">更多資訊</span>
      <span v-else>收合</span>
    </button>

    <!-- <div class="handle-receive-payment" v-show="showMore">
      <div class="payment__item">
        <div class="payment__item-title">處理日期</div>
        <div class="payment__item-content">2020-05-14</div>
      </div>

      <div class="payment__item handle-people">
        <div class="payment__item-title">處理人員</div>
        <div class="payment__item-content">001S00328 張美美</div>
      </div>

      <div class="payment__item">
        <div class="payment__item-title">應收金額</div>
        <div class="payment__item-content">$ 5,252</div>
      </div>

      <div class="payment__item">
        <div class="payment__item-title">實收金額</div>
        <div class="payment__item-content">$ 4,100</div>
      </div>

      <div class="payment__item">
        <div class="payment__item-title">未收金額</div>
        <div class="payment__item-content">$ 4,1000</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import OneProduct from '@/components/PurchaseHistory/OneProduct';
import { issueDetail } from '@/api/order';
import _ from 'lodash';

export default {
  components: {
    OneProduct
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderItems() {
      return _.get(this.order, 'order_item', []);
    },
    firstOrderItem() {
      return _.get(this.orderItems, '0', {});
    },
    id() {
      return `order_id` + this.order.order_id;
    },
    invoiceIssued() {
      // 無發票號碼,非0元訂單,無欠費
      if (
        _.isEmpty(_.get(this.order, 'invoice_no')) === false ||
        this.order.receivable_amount == 0 ||
        this.order.unpaid_amount != 0
      ) {
        return true;
      }
      return false;
    },
    isPrintInvoice() {
      return this.order.invoice_no == null ? '尚未開立' : this.order.invoice_no;
    }
  },
  data() {
    return {
      showMore: false
    };
  },
  methods: {
    showMoreInfo() {
      this.showMore = !this.showMore;
    },
    discountCourse(subtotal) {
      return subtotal * 0.1;
    },
    issueDetail() {
      issueDetail({ order_id: this.order.order_id }, url => {
        window.open(url.print_link);
      });
    }
  }
};
</script>
